module.exports = __webpack_public_path__ + "img/01b_Pinterest_651px.c0f2aea0.jpg";